import React from "react";

interface CheckboxWithLabelProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  id?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: any;
  touched?: any;
  readOnlyMode?: boolean;
  isPreview?: boolean;
}

const Checkbox: React.FC<CheckboxWithLabelProps> = ({
  checked,
  onChange,
  label,
  id,
  disabled = false,
  className,
  required = false,
  error = false,
  touched = false,
  readOnlyMode = false,
  isPreview = false,
}) => {
  return (
    <div className="d-flex flex-row align-items-center gap-3">
      <input
        type="checkbox"
        className="form-check-input fs-5"
        checked={checked}
        onChange={onChange}
        id={id}
        disabled={disabled || isPreview}
      />
      <span className="form-check-label mb-0">
        {label}
        {required && <span className="text-danger">*</span>}
      </span>
      {error && touched && <span className="text-danger">{error}</span>}
    </div>
  );
};

export default Checkbox;
